/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptInvitationCommandControllerAccept200,
  AcceptInvitationDto,
  CreateInvitationCommandControllerCreate201,
  CreateInvitationDto,
  GetInvitationResponseDto,
  ListInvitationsDto,
  ListInvitationsQueryControllerListParams,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Accept an invitation
 */
export const acceptInvitationCommandControllerAccept = (
  acceptInvitationDto: AcceptInvitationDto,
  signal?: AbortSignal,
) => {
  return axiosClient<AcceptInvitationCommandControllerAccept200>({
    url: `/v1/invitations/accept`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: acceptInvitationDto,
    signal,
  });
};

export const getAcceptInvitationCommandControllerAcceptMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvitationCommandControllerAccept>>,
    TError,
    { data: AcceptInvitationDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptInvitationCommandControllerAccept>>,
  TError,
  { data: AcceptInvitationDto },
  TContext
> => {
  const mutationKey = ["acceptInvitationCommandControllerAccept"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptInvitationCommandControllerAccept>>,
    { data: AcceptInvitationDto }
  > = (props) => {
    const { data } = props ?? {};

    return acceptInvitationCommandControllerAccept(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptInvitationCommandControllerAcceptMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptInvitationCommandControllerAccept>>
>;
export type AcceptInvitationCommandControllerAcceptMutationBody =
  AcceptInvitationDto;
export type AcceptInvitationCommandControllerAcceptMutationError = void;

/**
 * @summary Accept an invitation
 */
export const useAcceptInvitationCommandControllerAccept = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acceptInvitationCommandControllerAccept>>,
      TError,
      { data: AcceptInvitationDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acceptInvitationCommandControllerAccept>>,
  TError,
  { data: AcceptInvitationDto },
  TContext
> => {
  return useMutation(
    getAcceptInvitationCommandControllerAcceptMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Create a new invitation
 */
export const createInvitationCommandControllerCreate = (
  organisationSlug: string,
  createInvitationDto: CreateInvitationDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateInvitationCommandControllerCreate201>({
    url: `/v1/organisations/${organisationSlug}/invitations/create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createInvitationDto,
    signal,
  });
};

export const getCreateInvitationCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvitationCommandControllerCreate>>,
    TError,
    { organisationSlug: string; data: CreateInvitationDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvitationCommandControllerCreate>>,
  TError,
  { organisationSlug: string; data: CreateInvitationDto },
  TContext
> => {
  const mutationKey = ["createInvitationCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvitationCommandControllerCreate>>,
    { organisationSlug: string; data: CreateInvitationDto }
  > = (props) => {
    const { organisationSlug, data } = props ?? {};

    return createInvitationCommandControllerCreate(organisationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvitationCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInvitationCommandControllerCreate>>
>;
export type CreateInvitationCommandControllerCreateMutationBody =
  CreateInvitationDto;
export type CreateInvitationCommandControllerCreateMutationError = void;

/**
 * @summary Create a new invitation
 */
export const useCreateInvitationCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInvitationCommandControllerCreate>>,
      TError,
      { organisationSlug: string; data: CreateInvitationDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createInvitationCommandControllerCreate>>,
  TError,
  { organisationSlug: string; data: CreateInvitationDto },
  TContext
> => {
  return useMutation(
    getCreateInvitationCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get invitation details by token (public)
 */
export const getInvitationQueryControllerGetInvitation = (
  token: string,
  signal?: AbortSignal,
) => {
  return axiosClient<GetInvitationResponseDto>({
    url: `/v1/invitations/${token}`,
    method: "GET",
    signal,
  });
};

export const getGetInvitationQueryControllerGetInvitationQueryKey = (
  token: string,
) => {
  return [`/v1/invitations/${token}`] as const;
};

export const getGetInvitationQueryControllerGetInvitationQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
  TError = void,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInvitationQueryControllerGetInvitationQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>
  > = ({ signal }) => getInvitationQueryControllerGetInvitation(token, signal);

  return {
    queryKey,
    queryFn,
    enabled: token !== null && token !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInvitationQueryControllerGetInvitationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>
>;
export type GetInvitationQueryControllerGetInvitationQueryError = void;

export function useGetInvitationQueryControllerGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
  TError = void,
>(
  token: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
          TError,
          Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInvitationQueryControllerGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
  TError = void,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
          TError,
          Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInvitationQueryControllerGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
  TError = void,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get invitation details by token (public)
 */

export function useGetInvitationQueryControllerGetInvitation<
  TData = Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
  TError = void,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvitationQueryControllerGetInvitation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInvitationQueryControllerGetInvitationQueryOptions(
    token,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all invitations for an organisation
 */
export const listInvitationsQueryControllerList = (
  organisationSlug: string,
  params?: ListInvitationsQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListInvitationsDto>({
    url: `/v1/organisations/${organisationSlug}/invitations`,
    method: "GET",
    params,
    signal,
  });
};

export const getListInvitationsQueryControllerListQueryKey = (
  organisationSlug: string,
  params?: ListInvitationsQueryControllerListParams,
) => {
  return [
    `/v1/organisations/${organisationSlug}/invitations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListInvitationsQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
  TError = void,
>(
  organisationSlug: string,
  params?: ListInvitationsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListInvitationsQueryControllerListQueryKey(organisationSlug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInvitationsQueryControllerList>>
  > = ({ signal }) =>
    listInvitationsQueryControllerList(organisationSlug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: organisationSlug !== null && organisationSlug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListInvitationsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvitationsQueryControllerList>>
>;
export type ListInvitationsQueryControllerListQueryError = void;

export function useListInvitationsQueryControllerList<
  TData = Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
  TError = void,
>(
  organisationSlug: string,
  params: undefined | ListInvitationsQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listInvitationsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListInvitationsQueryControllerList<
  TData = Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
  TError = void,
>(
  organisationSlug: string,
  params?: ListInvitationsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listInvitationsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListInvitationsQueryControllerList<
  TData = Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
  TError = void,
>(
  organisationSlug: string,
  params?: ListInvitationsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all invitations for an organisation
 */

export function useListInvitationsQueryControllerList<
  TData = Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
  TError = void,
>(
  organisationSlug: string,
  params?: ListInvitationsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListInvitationsQueryControllerListQueryOptions(
    organisationSlug,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
